import React, { useEffect, useState } from "react";
import { postModificarOtrosParticipantesDQ } from "../../../services/PaginaRuta";
import ModalOtrosParticipantesEspecilidadesDQ from "./ModalOtrosParticipantesEspecilidadesDQ";
import ModalOtrosParticipantesHonorariosDQ from "./ModalOtrosParticipantesHonorariosDQ";
import ModalOtrosParticipantesMedicosDQX from "./ModalOtrosParticipantesMedicosDQX";

const ModalModificarOtrosPariticipantesDQ = ({
  setmodalOnModificarOtrosParticipantes,
  item,
  passActualizarOtrosParticipantes,
}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [isCheckedParticipo,setisCheckedParticipo]=useState(false)
    const [isParticipo, setisParticipo]=useState('')
  const [
    modalOnOtrosParticipantesMedicos,
    setmodalOnOtrosParticipantesMedicos,
  ] = useState(false);
  const [
    modalOnOtrosParticipantesEspecialidad,
    setmodalOnOtrosParticipantesEspecialidad,
  ] = useState(false);
  const [
    modalOnOtrosParticipantesHonorarios,
    setmodalOnOtrosParticipantesHonorarios,
  ] = useState(false);
  const [passOtrosParticipantesMedicos, setpassOtrosParticipantesMedicos] =
    useState({
      codigoMedigo: "",
      nombreMedico: "",
      codigoEspecialidad: "",
      nombreEspecialidad: "",
    });
  const [
    passOtrosParticipantesEspecialidad,
    setpassOtrosParticipantesEspecialidad,
  ] = useState({
    codigoEspecialidad: "",
    nombreEspecialidad: "",
  });
  const [
    passOtrosParticipantesHonorarios,
    setpassOtrosParticipantesHonorarios,
  ] = useState({
    codigoHonorario: "",
    nombreHonorario: "",
  });

  const passDataOtrosParticipantesHonorarios = (data) => {
    setpassOtrosParticipantesHonorarios(data);
    //console.log(data,'honorariossss')
    //seterrorHonorarioOtros('')
  };

  const passDataOtrosParticipantesEspecialidades = (data) => {
    setpassOtrosParticipantesEspecialidad(data);
    //console.log(data,'data medicos otros particpantes especialidades')
    setpassOtrosParticipantesMedicos({
      codigoMedigo: passOtrosParticipantesMedicos.codigoMedigo,
      nombreMedico: passOtrosParticipantesMedicos.nombreMedico,
      codigoEspecialidad: data.codigoEspecialidad,
      nombreEspecialidad: data.nombreEspecialidad,
    });
  };

  const passDataOtrosParticipantesMedicos = (data) => {
    setpassOtrosParticipantesMedicos(data);
    //console.log(data, "data medicos otros particpantes");
  };
  const handleCancelarClick = () => {
    setmodalOnModificarOtrosParticipantes(false);
  };
  const childOnOtrosParticipantesMedicos = () => {
    setmodalOnOtrosParticipantesMedicos(true);
  };
  const childOnOtrosParticipantesEspecialidades = () => {
    setmodalOnOtrosParticipantesEspecialidad(true);
  };
  const childOnOtrosParticipantesHonorarios = () => {
    setmodalOnOtrosParticipantesHonorarios(true);
  };
  useEffect(() => {
    //console.log(item,'itemmm')
    setpassOtrosParticipantesMedicos({
      codigoMedigo: item.PersCod,
      nombreMedico: item.PersNom,
      codigoEspecialidad: item.PersEsp,
      nombreEspecialidad: item.PersNomEP,
    });
    setpassOtrosParticipantesHonorarios({
      codigoHonorario: item.PersTip,
      nombreHonorario: item.PersTipDes,
    });
    if(item.PersEst == 'S'){
        setisParticipo('S')
        setisCheckedParticipo(true)
    }else if(item.PersEst == 'N'){
        setisParticipo('S')
        setisCheckedParticipo(false)
    }
    else{
        setisParticipo('N')
    }
  }, []);
  const handleOnsubmitModificar=(e)=>{
    e.preventDefault()
    const bodyModificar={
        PersCod: e.target.codigomedicootros.value,
        ProCirCod: item.ProCirCod,
        ProMCDpto: usuarioInfo.Sede,
        ProEmpCod: usuarioInfo.Empresa,
        PersTip: e.target.codigohonorariootros.value,
        PersEst: isParticipo,
        PersEsp: e.target.codigoespecialidadotros.value
    }
    //console.log(bodyModificar,'bodyModificar')
    postModificarOtrosParticipantesDQ(bodyModificar).then((res)=>{
        //console.log(res.data,'modificado otros participantes')
        passActualizarOtrosParticipantes(bodyModificar)
        setmodalOnModificarOtrosParticipantes(false)
    }).catch((error) => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true);
      //setLoading(true);
    });

  }
  const handleOnchangeParticipo=(e)=>{
    setisCheckedParticipo(!isCheckedParticipo)
    //console.log(!isCheckedParticipo,'isCheckedParticipo')
    if(!isCheckedParticipo){
        setisParticipo('S')
    }else{
        setisParticipo('N')
    }
  }
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)] max-w-7xl my-6 mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
              <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
              >
                Modificar Otros Participantes
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative">
            <form onSubmit={handleOnsubmitModificar}>
              <div className="flex-auto overflow-y-auto relative ">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium text-center text-2xl">
                  Otros Participantes
                </label>

                <div className="flex-auto overflow-y-auto relative p-1">
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Codigo Médico
                      </label>
                      <input
                        type="text"
                        //disabled={true}
                        //defaultValue={dataProcedimiento.ProCirCod}
                        name="codigomedicootros"
                        defaultValue={
                          passOtrosParticipantesMedicos.codigoMedigo
                        }
                        autoComplete="off"
                        onClick={childOnOtrosParticipantesMedicos}
                        disabled={true}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Participante
                      </label>
                      <input
                        type="text"
                        //disabled={true}
                        defaultValue={
                          passOtrosParticipantesMedicos.nombreMedico
                        }
                        disabled={true}
                        //defaultValue={dataProcedimiento.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Codigo Especialidad
                      </label>
                      <input
                        type="text"
                        //disabled={true}
                        name="codigoespecialidadotros"
                        onFocus={childOnOtrosParticipantesEspecialidades}
                        autoComplete="off"
                        defaultValue={
                          passOtrosParticipantesMedicos.codigoEspecialidad
                        }
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Especialidad
                      </label>
                      <input
                        type="text"
                        disabled={true}
                        defaultValue={
                          passOtrosParticipantesMedicos.nombreEspecialidad
                        }
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>
                <div className="flex-auto overflow-y-auto relative p-1">
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Codigo Honorario
                      </label>
                      <input
                        name="codigohonorariootros"
                        defaultValue={
                          passOtrosParticipantesHonorarios.codigoHonorario
                        }
                        onFocus={childOnOtrosParticipantesHonorarios}
                        //onChange={handleOnchangehonorariosotros}
                        type="text"
                        //disabled={true}
                        //defaultValue={dataProcedimiento.ProCirCod}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                        {/* {errorHonorarioOtros} */}
                      </label>
                    </div>
                    <div className="w-1/4  px-1 ">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                        Honorario
                      </label>
                      <input
                        defaultValue={
                          passOtrosParticipantesHonorarios.nombreHonorario
                        }
                        type="text"
                        disabled={true}
                        //defaultValue={dataProcedimiento.MPCedu}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-auto overflow-y-auto relative px-2">
                  <div className="flex flex-row py-2  text-left">
                    <div className="w-1/3 px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Participó?
                      </label>
                      <input
                        //value={isParticipo}
                        //checked={isParticipo}
                        //onChange={handleOnchangeParticipo}
                        checked={isCheckedParticipo}
                        onChange={handleOnchangeParticipo}
                        className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                        type="checkbox"
                        name="valoracionPreanestesica"
                        id="flexCheckDefault"
                        //checked={reqValoracionPreanestesica}
                        //onChange={handleOnchangeReqValoracionPreanestesica}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                  //onClick={handleOnclickModificarOtrosPartipantes}
                  type="submit"
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                  Modificar
                </button>
              </div>
            </form>
            </div>
          </div>
        </div>
      </div>
      {modalOnOtrosParticipantesMedicos ? (
        <ModalOtrosParticipantesMedicosDQX
          setmodalOnOtrosParticipantesMedicos={
            setmodalOnOtrosParticipantesMedicos
          }
          passDataOtrosParticipantesMedicos={passDataOtrosParticipantesMedicos}
        />
      ) : null}
      {modalOnOtrosParticipantesEspecialidad ? (
        <ModalOtrosParticipantesEspecilidadesDQ
          setmodalOnOtrosParticipantesEspecialidad={
            setmodalOnOtrosParticipantesEspecialidad
          }
          passOtrosParticipantesMedicos={passOtrosParticipantesMedicos}
          passDataOtrosParticipantesEspecialidades={
            passDataOtrosParticipantesEspecialidades
          }
        />
      ) : null}
      {modalOnOtrosParticipantesHonorarios ? (
        <ModalOtrosParticipantesHonorariosDQ
          setmodalOnOtrosParticipantesHonorarios={
            setmodalOnOtrosParticipantesHonorarios
          }
          passDataOtrosParticipantesHonorarios={
            passDataOtrosParticipantesHonorarios
          }
        />
      ) : null}
    </>
  );
};

export default ModalModificarOtrosPariticipantesDQ;
